<template>
  <div class="modal-confirm">
    <transition name="modal" v-if="showModal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header">
              <slot name="header">Delete this?</slot>
            </div>

            <div class="modal-body">
              <slot name="body">You cannot undo this. Are you sure?</slot>
            </div>

            <div class="modal-footer">
              <slot name="footer">
                <button class="modal-default-button" @click="respond(true)">Yeah!</button>
                <button class="modal-cancel-button" @click="respond(false)">Nope</button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "ModalConfirm",
  props: ["showMe"],
  data() {
    return {};
  },
  computed: {
    showModal() {
      return this.showMe;
    }
  },
  methods: {
    respond(response) {
      if (response) {
        this.$emit("confirmed", response);
      } else {
        this.$emit("confirmed", response);
      }
      // this.showModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9998;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -30%);

  width: 300px;
  margin: 0px auto;
  padding: 1rem;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header {
  margin: 0.5rem 1rem;
  color: #6192a2;
  font-weight: bold;
  font-size: 1.5rem;
}

.modal-body {
  margin: 1rem;
  font-size: 1rem;
}

.modal-default-button {
  float: left;
}
.modal-cancel-button {
  background-color: rgb(90, 90, 90);
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

// .modal-enter .modal-container,
// .modal-leave-active .modal-container {
// }
</style>
